module.exports = __webpack_public_path__ + "static/media/neko-young-bg.d76825d3.mp4";